import React from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import ChooseScreen from 'components/SearchTools/ChooseScreen';
import useEditPermission from 'lib/access/useEditPermission';
import { toDateString } from 'lib/dates/dateUtils';
import { Id } from 'lib/types';
import { useAnalysesQuery, useDeleteAnalysisMutation } from 'screens/Analysis/lib/queries';
import { Analysis } from 'screens/Analysis/lib/types';
import PortfoliosDropdown from 'screens/Backtest/lib/components/PortfoliosDropdown';
import { usePortfolioQuery } from 'screens/Portfolio/lib/queries';
import { Routes } from 'utils/constants';

const translationPath = 'chooseAnalysesScreen';

const columns = ['id', 'name', 'createdOn', 'updatedOn'];

const ChooseAnalysisScreen = () => {
  const history = useHistory();
  const { id, portfolioId } = useParams<{ id: Id | undefined; portfolioId: Id | undefined }>();
  const { analyses } = useAnalysesQuery(portfolioId);
  const { mutate: deleteAnalysis } = useDeleteAnalysisMutation();
  const { portfolio, isLoading } = usePortfolioQuery(portfolioId);
  const hasCreatePermission = useEditPermission(portfolio);

  const handleChangePortfolioId = (newPortfolioId: Id) => {
    history.push(
      generatePath(Routes.CHOOSE_ANALYSIS_WITH_PORTFOLIO, {
        portfolioId: newPortfolioId,
        id,
      })
    );
  };

  const cellFormatting = {
    createdOn: toDateString,
    updatedOn: toDateString,
  };

  return (
    <ChooseScreen
      dialogTranslatePath='analysisScreen.useSavePromptAndDialog'
      returnButtonProps={
        portfolioId
          ? {
              translateId: `${translationPath}.returnButtonToPortfolio`,
              route: generatePath(Routes.PORTFOLIO, { id: portfolioId }),
            }
          : undefined
      }
      topScreen={
        <PortfoliosDropdown onChange={handleChangePortfolioId} portfolioId={portfolioId} />
      }
      waitWhile={isLoading}
      key={translationPath}
      tableObjects={analyses}
      // @ts-ignore
      columns={columns}
      searchColumns={columns}
      cellFormatting={cellFormatting}
      searchValue={null}
      translationPath={translationPath}
      isTableWhite
      onNewClick={
        hasCreatePermission
          ? () => history.push(generatePath(Routes.NEW_ANALYSIS, { portfolioId, id }))
          : undefined
      }
      onRowClick={(clickedId: Id) =>
        history.push(generatePath(Routes.ANALYSIS, { id: clickedId, portfolioId }))
      }
      onDeleteRowClick={(obj: Analysis) => {
        deleteAnalysis(obj.id);
      }}
      editPermissionOverride={hasCreatePermission}
    />
  );
};

export default ChooseAnalysisScreen;
